/* ==========================================================================
   Maison Carthia - F8 "La Signature" motion engine
   ==========================================================================
   One shared IntersectionObserver that:
     1. Arms below-the-fold .mc-sig flourishes and draws them once on scroll.
     2. Injects a <span class="mc-swash"> gold underline after each homepage
        section heading and draws it once on scroll.

   Arming only ADDS motion. Content is already visible in server markup and
   the CSS keeps it visible without any class. Nothing here gates visibility.

   The hero entrance stagger is deliberately NOT here - it is pure CSS gated
   on html.mc-motion (added by the inline head script), so it survives even
   if this file is blocked or errors.

   No dependencies. Never touches cart/pubsub. No network requests.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mcMotion) return;
  window.__mcMotion = true;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  // When true, render final states immediately with no draw transition.
  var STATIC = reduce || design || !hasIO;

  // Headings that receive a swash: collection grid, atelier, newsletter.
  // Conservative and explicit so nothing outside the mc-home-* sections is
  // ever touched.
  var SWASH_SELECTOR = '.mc-vg__title, .mc-at__heading, .mc-nl__heading';
  var SWASH_SVG =
    '<svg viewBox="0 0 120 12" focusable="false" role="presentation">' +
    '<path pathLength="100" d="M2 9 C 22 3, 40 11, 62 7 C 84 3, 96 9, 118 4"/>' +
    '</svg>';

  var io = null;
  if (!STATIC) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.classList.contains('mc-sig--armed')) {
          el.classList.add('mc-sig--on');
        } else if (el.classList.contains('mc-swash')) {
          el.classList.add('mc-swash--on');
        }
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function belowFold(el) {
    return el.getBoundingClientRect().top > window.innerHeight * 0.92;
  }

  function armSignatures(root) {
    var sigs = root.querySelectorAll('.mc-sig');
    for (var i = 0; i < sigs.length; i++) {
      var el = sigs[i];
      if (el.getAttribute('data-mc-done')) continue;
      el.setAttribute('data-mc-done', '1');
      // Static path, or already in view: leave it fully drawn (server state).
      // Arming an in-view element would flash it un-drawn first.
      if (STATIC || !belowFold(el)) continue;
      el.classList.add('mc-sig--armed');
      io.observe(el);
    }
  }

  function injectSwashes(root) {
    var heads = root.querySelectorAll(SWASH_SELECTOR);
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (h.hasAttribute('data-mc-no-swash')) continue;
      if (h.querySelector('.mc-swash')) continue; // idempotent
      // The atelier's moment is the full signature; skip the swash there so
      // the gold is not doubled.
      var at = h.closest ? h.closest('.mc-at') : null;
      if (at && at.querySelector('.mc-sig')) continue;

      var span = document.createElement('span');
      span.className = 'mc-swash';
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = SWASH_SVG;
      h.appendChild(span);

      if (STATIC || !belowFold(span)) {
        span.classList.add('mc-swash--on'); // final state, no transition fires
      } else {
        io.observe(span);
      }
    }
  }

  function initWithin(root) {
    if (!root) return;
    injectSwashes(root);
    armSignatures(root);
  }

  function init() {
    initWithin(document);
    // Safety net: anything already in the first viewport that never fired
    // gets its final state. Below-fold choreography stays armed.
    if (!STATIC) {
      setTimeout(function () {
        var pending = document.querySelectorAll(
          '.mc-sig--armed:not(.mc-sig--on), .mc-swash:not(.mc-swash--on)'
        );
        for (var i = 0; i < pending.length; i++) {
          var el = pending[i];
          if (el.getBoundingClientRect().top < window.innerHeight) {
            el.classList.add(
              el.classList.contains('mc-swash') ? 'mc-swash--on' : 'mc-sig--on'
            );
          }
        }
      }, 3000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor re-inits the reloaded section (idempotent via data-mc-done
  // and the existing-.mc-swash guard). design=true keeps everything static.
  document.addEventListener('shopify:section:load', function (e) {
    initWithin(e.target);
  });
})();
